import React from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import Routes from "./routes/Routes";
import { crudFunctions } from "api";
import { CLIENTE } from "api/TYPES";
import { useDialog } from "Contexts/DialogContext";
import DatosIniciales from "pages/Login/DatosIniciales";
import { useQuery } from "react-query";
import { GoogleMapsProvider } from "pages/Tracking/GoogleMapsManager"; // Import the provider
import "./App.css";

require("analytics");

function App() {
  const actions = crudFunctions(CLIENTE);
  const { data: dataCliente, status } = useQuery(CLIENTE.name, actions.getAll);
  const [openDialog] = useDialog();

  return (
    <GoogleMapsProvider> {/* Wrap the entire app with GoogleMapsProvider */}
      <Router>
        <Switch>
          <Routes />
        </Switch>
      </Router>
    </GoogleMapsProvider>
  );
}

export default App;
